import { Link } from "react-router-dom";
import type { CaseItem } from "@/mocks/cases";
import { formatHeat } from "@/utils/format";

export default function Hero({ featured }: { featured: CaseItem }) {
  return (
    <section id="headline" className="relative w-full min-h-[520px] md:min-h-[620px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20editorial%20hero%20scene%20of%20scattered%20blurred%20documents%2C%20a%20brass%20magnifying%20glass%20and%20a%20red%20sealing%20wax%20stamp%20on%20a%20dark%20warm%20table%2C%20crimson%20and%20gold%20tones%2C%20cinematic%20lighting%2C%20no%20faces%2C%20high%20detail&width=1600&height=900&seq=gt-hero-2026&orientation=landscape"
        alt="瓜田档案独家黑料实锤证据链头条档案背景图"
        title="独家黑料证据链 - 头条档案"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/45 to-black/30" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />

      <div className="relative w-full h-full px-4 md:px-8 py-16 md:py-24 flex flex-col justify-end min-h-[520px] md:min-h-[620px]">
        <div className="max-w-3xl animate-rise">
          <div className="flex flex-wrap items-center gap-2 mb-5">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-md bg-accent-500 text-primary-950 text-xs font-medium whitespace-nowrap">
              <i className="ri-live-line" />
              今日头条档案
            </span>
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-md bg-white/15 text-white text-xs backdrop-blur whitespace-nowrap">
              <i className="ri-links-line" />
              出处可查 · 证据链持续补充
            </span>
          </div>

          <h1 className="font-heading text-2xl md:text-4xl lg:text-[42px] font-bold leading-tight text-white">
            独家黑料档案｜{featured.title}
          </h1>

          <p className="mt-5 text-sm md:text-base leading-relaxed text-white/80 max-w-2xl">{featured.summary}</p>

          <div className="mt-6 flex flex-wrap items-center gap-x-6 gap-y-2 text-xs md:text-sm text-white/75">
            <span className="flex items-center gap-1.5">
              <i className="ri-folder-open-line" />
              {featured.categoryName}
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-fire-line" />
              热度 {formatHeat(featured.heat)}
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-calendar-line" />
              {featured.publishedAt}
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-loader-4-line" />
              {featured.status}
            </span>
          </div>

          <div className="mt-8 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
            <Link
              to={`/archive/${featured.id}`}
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-file-search-line" />
              查看完整证据链
            </Link>
            <Link
              to="/archive"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-white/40 text-white text-sm font-medium whitespace-nowrap hover:bg-white/10 transition-colors cursor-pointer"
            >
              浏览全部档案
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}